import { render } from "./SemiCircle.vue?vue&type=template&id=3d489173&scoped=true"
import script from "./SemiCircle.vue?vue&type=script&lang=js"
export * from "./SemiCircle.vue?vue&type=script&lang=js"

import "./SemiCircle.vue?vue&type=style&index=0&id=3d489173&lang=scss&scoped=true"

import exportComponent from "/Applications/dev/FLEXX_FREIGHT/flexx-freight-stats/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d489173"]])

export default __exports__